import { socket } from "../index";
import { Message } from "../type";
import emitFreezeAll from "./freezeAll";
import emitFreezeUser from "./freezeUser";
import emitKickUser from "./kickUser";
import emitUnfreezeAll from "./unfreezeAll";

const emitSendMessage = (
  roomId: string,
  message: Message
) => {
  if (typeof message.contents === 'string') {
    const command = message.contents.split(' ')[0];
    if (command === '/벙어리') {
      const userId = message.contents.split(' ')[1];
      emitFreezeUser(userId);
      return;
    } else if (command === '/강퇴') {
      const userId = message.contents.split(' ')[1];
      emitKickUser(userId);
      return;
    } else if (command === '/얼리기') {
      emitFreezeAll();
      return;
    } else if (command === '/얼리기해제') {
      emitUnfreezeAll();
      return;
    }
  }
  socket?.emit('SEND_MESSAGE', { 
    roomId,
    message,
  });
}

export default emitSendMessage;